import { useEffect } from "react";
import { firePopUnder, popUnderAlreadyFired } from "@/lib/popunder";

/**
 * Pop-under: on the first qualifying click of a session, the current page is
 * re-opened in a new tab and the original tab navigates to the affiliate URL.
 * Skips clicks on Viator affiliate links.
 */
export function PopUnder() {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (popUnderAlreadyFired()) return;

      // Don't fire when the user is clicking a Viator affiliate link
      const anchor = (e.target as HTMLElement | null)?.closest?.("a");
      if (
        anchor?.href &&
        /(^|\.)viator\.com/i.test(new URL(anchor.href, window.location.href).hostname)
      ) {
        return;
      }

      firePopUnder();
    };

    document.addEventListener("click", handler, { capture: true });
    return () => document.removeEventListener("click", handler, { capture: true });
  }, []);

  return null;
}
